<body>
  @if (isLoggedIn) {
    <nav-trail></nav-trail>
  }
  <router-outlet></router-outlet>
  <span id="footerVersion" style="position: absolute; right: 4px; bottom: 0; font-size: smaller; pointer-events: none;">{{programInfoService.programVersion}}</span>
</body>
